/**
 * @file StageDot.tsx
 * @description Точка цвета стадии сделки (phase19.31, SC28): цвет, который
 * задал магазин, показывается только точкой — в шапке колонки доски и в
 * строке настроек стадий. Чужое значение цвета (не hex) в стиль не пускаем —
 * тогда точка нейтрального серого.
 */

import { safeStageColor } from "../../lib/crm-deal-view";

export function StageDot({ color }: { color: string | null }) {
  const dot = safeStageColor(color);
  return (
    <span
      aria-hidden
      className="size-2.5 shrink-0 rounded-full bg-on-surface-variant"
      style={dot ? { backgroundColor: dot } : undefined}
    />
  );
}
